import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaWallet } from 'react-icons/fa';

export const HeaderWalletBadge = ({ balance }) => {
  const navigate = useNavigate();

  if (balance === null || balance === undefined) return null;

  return (
    <div
      className="header-wallet-badge d-flex align-items-center gap-1 px-3 py-1 rounded-pill"
      onClick={() => navigate('/listar-ganhos')}
      title="Mi Billetera"
      style={{
        cursor: 'pointer',
        backgroundColor: 'rgba(14, 171, 176, 0.15)',
        color: 'var(--bry-accent, #0EABB0)',
        border: '1px solid var(--bry-accent, #0EABB0)',
        fontSize: '0.85rem',
        fontWeight: 700,
        transition: 'all 0.2s ease'
      }}
    >
      <FaWallet size={13} style={{ color: 'var(--bry-accent, #0EABB0)' }} />
      <span className="text-white ms-1">
        ${parseFloat(balance).toFixed(2)}
      </span>
    </div>
  );
};

export default HeaderWalletBadge;
